/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { BannerAndModalMessageConfigurationModelDto } from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class BannerAndModalMessageConfigurationClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsGetBannerAndModalMessageConfiguration
   * @summary Returns the banner and modal message configurations.
   * @request GET:/BannerAndModalMessageConfiguration
   */
  informationCenterConfigurationsGetBannerAndModalMessageConfiguration = (
    params: RequestParams = {},
  ) =>
    this.http.request<BannerAndModalMessageConfigurationModelDto[], any>({
      path: `/BannerAndModalMessageConfiguration`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsPost2
   * @summary Creates the banner and modal message.
   * @request POST:/BannerAndModalMessageConfiguration
   */
  informationCenterConfigurationsPost2 = (
    data: BannerAndModalMessageConfigurationModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BannerAndModalMessageConfigurationModelDto, any>({
      path: `/BannerAndModalMessageConfiguration`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsPut2
   * @summary Updates the passed banner and modal message.
   * @request PUT:/BannerAndModalMessageConfiguration/{id}
   */
  informationCenterConfigurationsPut2 = (
    id: number,
    data: BannerAndModalMessageConfigurationModelDto,
    params: RequestParams = {},
  ) =>
    this.http.request<BannerAndModalMessageConfigurationModelDto, any>({
      path: `/BannerAndModalMessageConfiguration/${id}`,
      method: "PUT",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsDeleteBannerAndModalMessageConfiguration
   * @summary Deletes the banner and modal message for the specified Id.
   * @request DELETE:/BannerAndModalMessageConfiguration/{id}
   */
  informationCenterConfigurationsDeleteBannerAndModalMessageConfiguration = (
    id: number,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/BannerAndModalMessageConfiguration/${id}`,
      method: "DELETE",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags InformationCenterConfigurations
   * @name InformationCenterConfigurationsChangeStatus
   * @summary Provides the endpoint to change the status for the banner and modal messages Id.
   * @request POST:/BannerAndModalMessageConfiguration/{id}/ChangeStatus/{status}
   */
  informationCenterConfigurationsChangeStatus = (
    id: number,
    status: string,
    params: RequestParams = {},
  ) =>
    this.http.request<boolean, any>({
      path: `/BannerAndModalMessageConfiguration/${id}/ChangeStatus/${status}`,
      method: "POST",
      format: "json",
      ...params,
    });
}
